import { cn } from '@rouvydev/web-components/utils'
import { NormalizedLink } from '~/components/normalized-link.tsx'

export type LogoProps = {
  title: string
  image: string
  link?: string
  className?: string
}

export function Logo({ title, image, link, className }: LogoProps) {
  const logo = (
    <img
      src={image}
      alt={title}
      className={cn('w-full object-contain', className)}
    />
  )

  return (
    <div className={cn('flex items-center gap-2', className)}>
      {link ? (
        <NormalizedLink title={title} to={link} className="inline-block w-full">
          {logo}
        </NormalizedLink>
      ) : (
        logo
      )}
    </div>
  )
}
